// src/components/SuperAdminSubscriptions/index.jsx
import { useTheme, useMediaQuery } from "@mui/material";
import SuperAdminSubscriptionsDesktop from "./SuperAdminSubscriptionsDesktop";
import SuperAdminSubscriptionsMobile from "./SuperAdminSubscriptionsMobile";

export default function SuperAdminSubscriptions() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return isMobile ? (
    <SuperAdminSubscriptionsMobile />
  ) : (
    <SuperAdminSubscriptionsDesktop />
  );
}
